function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("polygon", {
    style: {
      fill: "#4DC430"
    },
    points: "235.2,66.4 208,75.2 185.6,33.6 201.6,22.4 210.4,29.6 206.4,5.6 243.2,0 245.6,19.2 252,13.6 252,66.4 "
  }), React.createElement("polygon", {
    style: {
      fill: "#3AAD1A"
    },
    points: "268.8,66.4 296,75.2 318.4,33.6 302.4,22.4 293.6,29.6 297.6,5.6 260.8,0 258.4,19.2 252,13.6 252,66.4 "
  }), React.createElement("circle", {
    style: {
      fill: "#FF4800"
    },
    cx: 252,
    cy: 274.4,
    r: 229.6
  }), React.createElement("path", {
    style: {
      fill: "#C92B00"
    },
    d: "M252,44.8c126.4,0,229.6,102.4,229.6,229.6C481.6,400.8,379.2,504,252,504"
  }), React.createElement("circle", {
    style: {
      fill: "#FF794A"
    },
    cx: 252,
    cy: 274.4,
    r: 182.4
  }), React.createElement("path", {
    style: {
      fill: "#EF683F"
    },
    d: "M252,92c100.8,0,182.4,81.6,182.4,182.4S352.8,456.8,252,456.8"
  }), React.createElement("circle", {
    style: {
      fill: "#B21010"
    },
    cx: 252,
    cy: 274.4,
    r: 146.4
  }), React.createElement("path", {
    style: {
      fill: "#A00000"
    },
    d: "M252,128c80.8,0,146.4,65.6,146.4,146.4S332.8,420.8,252,420.8"
  }), React.createElement("rect", {
    x: 220,
    y: 116,
    style: {
      fill: "#EF683F"
    },
    width: 64,
    height: 312
  }), React.createElement("g", null, React.createElement("rect", {
    x: 220,
    y: 116,
    style: {
      fill: "#FF794A"
    },
    width: 32,
    height: 312
  }), React.createElement("circle", {
    style: {
      fill: "#FF794A"
    },
    cx: 252,
    cy: 274.4,
    r: 56
  })), React.createElement("path", {
    style: {
      fill: "#EF683F"
    },
    d: "M252,218.4c31.2,0,56,25.6,56,56c0,31.2-24.8,56-56,56"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M169.6,205.6L169.6,205.6l28,15.2l-8-32.8l0,0c-0.8,0-1.6-2.4-2.4-4c-4.8-6.4-13.6-6.4-19.2-2.4 c-6.4,4.8-7.2,13.6-2.4,20C166.4,203.2,168,204.8,169.6,205.6z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M149.6,255.2L149.6,255.2l32.8-0.8L159.2,232l0,0c-1.6-1.6-3.2-2.4-4.8-3.2 c-7.2-3.2-15.2,0.8-18.4,8c-2.4,7.2,0.8,15.2,8,18.4C145.6,254.4,147.2,255.2,149.6,255.2z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M158.4,312L158.4,312l24-22.4l-32.8-1.6l0,0c-1.6,0-4,0-5.6,0.8c-7.2,2.4-11.2,10.4-8,17.6 c2.4,7.2,10.4,11.2,17.6,8C155.2,314.4,156.8,313.6,158.4,312z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M189.6,358.4L189.6,358.4l8-31.2l-28,16l0,0c-1.6,0.8-3.2,2.4-4.8,4c-4.8,6.4-3.2,15.2,2.4,19.2 c6.4,4.8,15.2,3.2,19.2-2.4C188.8,362.4,189.6,360,189.6,358.4z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M334.4,205.6L334.4,205.6l-28,15.2l8-32.8l0,0c0.8,0,1.6-2.4,2.4-4c4.8-6.4,13.6-6.4,19.2-2.4 c6.4,4.8,7.2,13.6,2.4,20C337.6,203.2,336,204.8,334.4,205.6z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M354.4,255.2L354.4,255.2l-32.8-0.8l23.2-22.4l0,0c1.6-1.6,3.2-2.4,4.8-3.2c7.2-3.2,15.2,0.8,18.4,8 c2.4,7.2-0.8,15.2-8,18.4C358.4,254.4,356.8,255.2,354.4,255.2z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M345.6,312L345.6,312l-24-22.4l32.8-1.6l0,0c1.6,0,4,0,5.6,0.8c7.2,2.4,11.2,10.4,8,17.6 c-2.4,7.2-10.4,11.2-17.6,8C348.8,314.4,347.2,313.6,345.6,312z"
  }), React.createElement("path", {
    style: {
      fill: "#FFCD50"
    },
    d: "M314.4,358.4L314.4,358.4l-8-31.2l28,16l0,0c1.6,0.8,3.2,2.4,4.8,4c4.8,6.4,3.2,15.2-2.4,19.2 c-6.4,4.8-15.2,3.2-19.2-2.4C315.2,362.4,314.4,360,314.4,358.4z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.1b270a08.svg";
export { ForwardRef as ReactComponent };